import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/sections/Hero";
import { About } from "../components/sections/About";
import { Products } from "../components/sections/Products";
import { Capacity } from "../components/sections/Capacity";
import { WhyChooseUs } from "../components/sections/WhyChooseUs";
import { Machinery } from "../components/sections/Machinery";
import { SafetyQuality } from "../components/sections/SafetyQuality";
import { Gallery } from "../components/sections/Gallery";
import { CallToAction } from "../components/sections/CallToAction";
import { Contact } from "../components/sections/Contact";
export function Home() {
  const {
    hash
  } = useLocation();

  // Supports arriving from a legal page with an anchor (e.g. /#contacto).
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const target = document.querySelector(hash);
    if (target) target.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, [hash]);
  return <main data-id="element-296" data-mp="30w02vw8itc1x">
      <Hero data-id="element-297" data-mp="30ufbgfhi698a" />
      <About data-id="element-298" data-mp="2vxottnq1v5kr" />
      <Products data-id="element-299" data-mp="2vx6rqagphx4x" />
      <Capacity data-id="element-300" data-mp="2vyq6txqmm254" />
      <WhyChooseUs data-id="element-301" data-mp="2vy82sexq2jmn" />
      <Machinery data-id="element-302" data-mp="2vvlv8fau044f" />
      <SafetyQuality data-id="element-303" data-mp="2qylpk5hw93du" />
      <Gallery data-id="element-304" data-mp="2qy2ftc2edlaw" />
      <CallToAction data-id="element-305" data-mp="2qxkei10vogw4" />
      <Contact data-id="element-306" data-mp="2qx0xcmj1xwj5" />
    </main>;
}